import { useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { FiMail, FiMessageCircle, FiPhone } from "react-icons/fi";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const whatsappNumber = "2348077857683";
    const text = `Hello CodeCamp!\n\nName: ${formData.name || "N/A"}\nCompany: ${formData.company || "N/A"}\nEmail: ${formData.email || "N/A"}\nPhone: ${formData.phone || "N/A"}\n\nChallenge: ${formData.message || "N/A"}`;
    const encodedText = encodeURIComponent(text);

    window.open(
      `https://wa.me/${whatsappNumber}?text=${encodedText}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <div className="page-hero">
      <Container>
        <Row className="g-4 align-items-start">
          <Col lg={5}>
            <h1 className="hero-title">Let’s talk about your next move</h1>
            <p className="hero-copy mt-3">
              Tell us what challenge you are trying to solve and we will help
              you shape the right solution.
            </p>
            <div className="mt-4">
              <Card className="contact-card p-3 mb-3">
                <div className="d-flex align-items-center gap-3">
                  <FiPhone className="fs-4 text-primary" />
                  <div>
                    <div className="fw-semibold">Phone</div>
                    <div className="text-muted">+234 807 785 7683</div>
                  </div>
                </div>
              </Card>
              <Card className="contact-card p-3 mb-3">
                <div className="d-flex align-items-center gap-3">
                  <FiMail className="fs-4 text-primary" />
                  <div>
                    <div className="fw-semibold">Email</div>
                    <div className="text-muted">contact@codecamp.ng</div>
                  </div>
                </div>
              </Card>
              <Card className="contact-card p-3">
                <div className="d-flex align-items-center gap-3">
                  <FiMessageCircle className="fs-4 text-primary" />
                  <div>
                    <div className="fw-semibold">WhatsApp</div>
                    <div className="text-muted">
                      Start a quick conversation with our team
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          </Col>
          <Col lg={7}>
            <div className="page-card">
              <Form onSubmit={handleSubmit}>
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Your name"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Label>Company</Form.Label>
                    <Form.Control
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      placeholder="Company name"
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="name@example.com"
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Phone number"
                    />
                  </Col>
                  <Col xs={12}>
                    <Form.Label>
                      What challenge are you trying to solve?
                    </Form.Label>
                    <Form.Control
                      name="message"
                      as="textarea"
                      rows={5}
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Tell us about your business goals and current bottlenecks."
                      required
                    />
                  </Col>
                  <Col xs={12}>
                    <Button type="submit" className="rounded-pill px-4">
                      Send message
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Contact;
